import DataImport from './Index.vue'

DataImport.install = function(Vue) {
  Vue.component(DataImport.name, DataImport)
}

export default DataImport
